import { render } from "./RegistroConductores.vue?vue&type=template&id=826fbc28&scoped=true"
import script from "./RegistroConductores.vue?vue&type=script&lang=js"
export * from "./RegistroConductores.vue?vue&type=script&lang=js"

import "./RegistroConductores.vue?vue&type=style&index=0&id=826fbc28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826fbc28"]])

export default __exports__